export const SERVER_PATH = process.env.REACT_APP_SERVER_PATH;
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export const MAIN_TOKEN = sessionStorage.getItem('token');

export const axiosConfig = {
    headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        'Authorization': `${MAIN_TOKEN}`
    }
  };
export const axiosConfig1 = {
    headers: {
        "Content-Type": "multipart/form-data",
        'Authorization': `${MAIN_TOKEN}` 
    }
  };


  export const valdateJson = (str) =>{
    try {
      JSON.parse(str)
    } catch (error) {
      return false
    }
    return true
  }
  export const ordinal_suffix_of = (i)=> {
    if(i !== undefined && 1 !== null && parseInt(i) > 0){
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
  }
  }

  export const nairaformat = (item)=>{
    if(parseFloat(item) > 0){
    let f = new Intl.NumberFormat(undefined,{style:'currency', currency:'NGR'})
    return f.format(item)
    }
  }

  export const menu = [
    {
      id:1,
      name:'Profile',
      icon:'admission.png',
      link:'/profile'
    },
    {
      id:2,
      name:'My School',
      icon:'school.png',
      link:'/index'
    },
    {
      id:3,
      name:'Report Card',
      icon:'report.png',
      link:'/report'
    },
    {
      id:4,
      name:'Fees',
      icon:'fee.png',
      link:'/fee'
    },
    {
      id:5,
      name:'Attendance',
      icon:'student.png',
      link:'/attendance'
    },
    {
      id:6,
      name:'Commendations/Awards',
      icon:'theme.png',
      link:'/commendation'
    },
    {
      id:7,
      name:'Misbehaviors',
      icon:'class.png',
      link:'/misbehavior'
    },
    {
      id:8,
      name:'Lessons',
      icon:'assessment.png',
      link:'/feedback'
    },
    {
      id:9,
      name:'CBT',
      icon:'cbt.png',
      link:'/cbt'
    },
    {
      id:10,
      name:'Feedback',
      icon:'feedback.png',
      link:'/feedback'
    },
  ]